import api from "@/api/index";

export default {
  //PUBLIC
  list(credentials) {
    return api().get("invest/list", credentials);
  },
  //MEMBER
  submit(credentials) {
    return api().post("contract/submit", credentials);
  },
  unstake(credentials) {
    return api().post("contract/unstake", credentials);
  },
  contract(credentials) {
    return api().get("contract", credentials);
  },
  listByAddress(credentials) {
    return api().post("contract/address", credentials);
  },
  claim(credentials) {
    return api().post("contract/claim", credentials);
  },
  //ADMIN
  delete(credentials) {
    return api().post("invest/delete", credentials);
  },
  create(credentials) {
    return api().post("invest/create", credentials);
  },
  update(credentials) {
    return api().post("invest/update", credentials);
  },
};
